<template>
  <v-dialog
      v-model="dialog"
      width="600"
      large
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          v-if="item == null"
          v-bind="attrs"
          v-on="on"
      >
        mdi-plus-box
      </v-icon>
      <v-icon
          v-else
          small
          v-bind="attrs"
          v-on="on"
      >
        mdi-pencil-circle
      </v-icon>
    </template>
    <v-card>
      <v-card-title>
        Holiday
      </v-card-title>
      <v-card-text>
        <v-form
            ref="PublicHolidayNewForm"
            v-model="form"
        >
          <v-row>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required]"
                  label="Date"
                  type="date"
                  v-model="localItem.dt"
                  :value="localItem.dt"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  :rules="[rules.required]"
                  label="Holiday"
                  type="text"
                  v-model="localItem.public_holiday"
                  :value="localItem.public_holiday"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
            @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="item == null"
            :disabled="!form"
            @click="onSave"
        >
          Add
        </v-btn>
        <v-btn
            v-else
            :disabled="!form"
            @click="onSave"
        >
          Save
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'PublicHolidayNewEditDialog',
  props: {
    item: {default: null},
    length: {default: null},
    disabled: {default: false}
  },

  computed: {
    ...mapGetters('CalendarDate', ['getColumns',]),
    ...mapFields('Contract', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'lang',]),
    ...mapFields('CalendarDate', {itemListHuman: 'itemList'},),

  },

  methods: {
    ...mapActions('CalendarDate', ['fetchSaveItemField']),


    onSave() {
      console.log('onSave', this.localItem)
      let fields_dict = {}
      fields_dict['id'] = this.localItem.id
      fields_dict['dt'] = this.localItem.dt
      fields_dict['public_holiday'] = this.localItem.public_holiday

      this.fetchSaveItemField({
        itemId: this.localItem.id,
        fields_dict: fields_dict,
        dto_model: {to_consumer: 'CalendarDatePublicHolidayDTO', from_consumer: 'CalendarDatePublicHolidayDTO'}
      })
      this.dialog = false
      if (this.item === null)
        this.$refs['PublicHolidayNewForm'].resetValidation()
        this.localItem = {
          id: null,
          dt: null,
          public_holiday: null,
        }
    },
  },

  mounted() {
    // console.log('mounted', this.item)
    if (this.item != null)
      this.localItem = this.item
  },

  data() {
    return {
      dialog: false,
      itemSaved: null,
      form: false,
      localItem: {
        id: null,
        dt: null,
        public_holiday: null,
      },
      rules: {
        min: len => v => (v || '').length >= len || `Invalid character length, required great or equal ${len}`,
        max: len => v => (v || '').length <= len || `Invalid character length, required low or equal ${len}`,
        required: v => !!v || 'This field is required',
      },
    }
  }
}

</script>


<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
}

.no-spin input::-webkit-outer-spin-button,
.no-spin input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

</style>